export default () => ({
    authenticated: false,
    persona: {},
    empresa: {},
    empresas: [],
})